import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import { supabase } from './lib/supabase';
import PrintTool from './components/PrintTool'

export default function App() {
  const [session, setSession] = useState(null);
  const [loadingAuth, setLoadingAuth] = useState(true);

  useEffect(() => {
    const getSession = async () => {
      const { data } = await supabase.auth.getSession();
      setSession(data.session);
      setLoadingAuth(false);
    };

    getSession();

    const { data: listener } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });

    return () => {
      listener.subscription.unsubscribe();
    };
  }, []);

  if (loadingAuth) return null;

  return (
    <Routes>
      {/* Login */}
      <Route
        path="/login"
        element={
          session ? <Navigate to="/" /> : <Login />
        }
      />

      {/* Protected route */}
      <Route
        path="/"
        element={
          session ? <PrintTool /> : <Navigate to="/login" />
        }
      />
    </Routes>
  );
}